export default class DtoDespoliation {
    constructor(obj) {
        this.idStation = obj.idStation
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.despoliationMode = obj.despoliationMode
        this.comment = obj.comment
    }
}